import React from 'react';

import { Header, Footer, ScrollTop, ScrollToTop } from './components';
import { HomePage, AboutUs, TestimonialsPage, BlogGrid, BlogList, BlogSingle, Login, Register, ForgotPwd, ShopGrid, ShopList, Cart, Checkout, Contact, ProductSingle, Wishlist, ServiceSingle, TeamPage, ServicePage, OrderConfirmation, FaqPage, CareerPage, CareerSingle, CareerForm, TeamSingle, PartnersPage, EventPage, EventSingle, MenuCategory, MenuList, MenuTabs, MenuSingle, Gallery, PortfolioPage, PortfolioSingle, PricingPage, VenuePage, VenueSingle, BookingPage, QuotePage } from './sections';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';



const App = () => {

  return (

    <div className='App'>

      {/* Component to Scroll to Top on Route Change */}
      <ScrollToTop />

      {/* Render the header component */}
      <Header />

      <Routes>

        {/*Home*/}
        <Route path='/' element={<HomePage />} />

        {/*About*/}
        <Route path='/About-us' element={<AboutUs />} />
        <Route path='/Team' element={<TeamPage />} /> 
        <Route path='/Team/:id' element={<TeamSingle />} />
        <Route path='/Team/Team-Single' element={<TeamSingle />} />
        <Route path='/Testimonials' element={<TestimonialsPage />} />
        <Route path='/Faqs' element={<FaqPage />} />

        {/*Services*/}
        <Route path='/Services' element={<ServicePage />} />
        <Route path='/Services/:id' element={<ServiceSingle />} />
        <Route path='/Services/Service-Single' element={<ServiceSingle />} />

        {/*Menu*/}
        <Route path='/Menu-Category' element={<MenuCategory />} />
        <Route path='/Menu' element={<MenuList />} />
        <Route path='/Menu/:search' element={<MenuList />} />
        <Route path='/Menu-List' element={<MenuList />} />
        <Route path='/Menu-Tabs' element={<MenuTabs />} />
        <Route path='/Menu/:id/Menu-Single' element={<MenuSingle />} />
        <Route path='/Menu/Menu-Single' element={<MenuSingle />} />

        {/*Pages*/}
        <Route path='/Gallery' element={<Gallery />} />   

        <Route path='/Portfolio' element={<PortfolioPage />} />
        <Route path='/Portfolio/:id' element={<PortfolioSingle />} />
        <Route path='/Portfolio/Portfolio-Single' element={<PortfolioSingle  />} />

        <Route path='/Careers' element={<CareerPage />} />
        <Route path='/Careers/:id' element={<CareerSingle />} />
        <Route path='/Careers/Position-Single' element={<CareerSingle />} />
        <Route path='/Career-Form' element={<CareerForm />} />

        <Route path='/Pricing' element={<PricingPage />} />

        <Route path='/Events' element={<EventPage />} />   
        <Route path='/Events/:id' element={<EventSingle />} />   
        <Route path='/Events/Event-Single' element={<EventSingle />} /> 

        <Route path='/Venues' element={<VenuePage />} />
        <Route path='/Venues/:id' element={<VenueSingle />} />
        <Route path='/Venues/Venue-Single' element={<VenueSingle />} />

        <Route path='/Book-Table' element={<BookingPage />} />
        <Route path='/Get-Quote' element={<QuotePage />} />
        <Route path='/Partners' element={<PartnersPage />} />

        {/*Blogs*/}
        <Route path='/Blog-grid' element={<BlogGrid />} /> 
        <Route path='/Blogs/category/:category' element={<BlogList />} /> 
        <Route path='/Blogs/tag/:tag' element={<BlogList />} /> 
        <Route path='/Blogs/search/:search' element={<BlogList />} /> 
        <Route path='/Blog-list' element={<BlogList />} /> 
        <Route path='/Blogs/:id' element={<BlogSingle  />} />
        <Route path='/Blogs/Blog-Single' element={<BlogSingle />} />

        {/*Shop*/}
        <Route path='/Shop-grid' element={<ShopGrid />} />  
        <Route path='/Shop/category/:category' element={<ShopList />} /> 
        <Route path='/Shop/tag/:tag' element={<ShopList />} /> 
        <Route path='/Shop/search/:search' element={<ShopList />} /> 
        <Route path='/Shop-list' element={<ShopList />} />
        <Route path='/Shop/:id' element={<ProductSingle />} />
        <Route path='/Shop/Product-Single' element={<ProductSingle />} /> 
        <Route path='/Wishlist' element={<Wishlist />} />
        <Route path='/Cart' element={<Cart />} />
        <Route path='/Checkout' element={<Checkout />} />
        <Route path='/OrderConfirmation' element={<OrderConfirmation />} />
        <Route path='/Login' element={<Login />} />  
        <Route path='/Register' element={<Register />} /> 
        <Route path='/Forgot-pwd' element={<ForgotPwd />} /> 

        {/*Contact*/}
        <Route path='/Contact-us' element={<Contact />} /> 

      </Routes>

      {/* Render the footer component */}
      <Footer />

      {/* Scroll to top button */}
      <ScrollTop />
      <ToastContainer />
      
    </div>

  )
}

export default App;
